var map = {
	"./bankassurance-auto.svg": [
		"ee3e",
		"chunk-2d230c28"
	],
	"./bankassurance-health.svg": [
		"4f78",
		"chunk-2d0cca09"
	],
	"./bankassurance-travel.svg": [
		"f9a6",
		"chunk-2d22e0be"
	],
	"./cards-flex.svg": [
		"002d",
		"chunk-2d0a2d68"
	],
	"./cards-kamba.svg": [
		"dc57",
		"chunk-2d229057"
	],
	"./cards-multicaixa.svg": [
		"a30e",
		"chunk-2d207e9d"
	],
	"./cards-withdraw.svg": [
		"be47",
		"chunk-2d21aefc"
	],
	"./cards.svg": [
		"f119",
		"chunk-2d22bce9"
	],
	"./company-payments-merchant.svg": [
		"4e58"
	],
	"./definitions-accounts-groups.svg": [
		"24b9",
		"chunk-2d0b2acf"
	],
	"./definitions-active-channels.svg": [
		"c50c",
		"chunk-2d216edb"
	],
	"./definitions-history.svg": [
		"9ad7",
		"chunk-2d0f0291"
	],
	"./definitions-notifications.svg": [
		"3a76",
		"chunk-2d0c42e3"
	],
	"./definitions-password.svg": [
		"b758",
		"chunk-2d21026e"
	],
	"./definitions-username.svg": [
		"ef5c",
		"chunk-2d231025"
	],
	"./emptyState/acessions.svg": [
		"1055",
		"chunk-2d0aa1f5"
	],
	"./emptyState/approvals.svg": [
		"5e38",
		"chunk-2d0d3a2b"
	],
	"./emptyState/available-soon.svg": [
		"c6d6",
		"chunk-2d2178bb"
	],
	"./emptyState/bankassurance-policies.svg": [
		"985f",
		"chunk-2d0e6326"
	],
	"./emptyState/batchfile-cards.svg": [
		"54a9",
		"chunk-2d0c87cd"
	],
	"./emptyState/batchfile-consult-cards.svg": [
		"a73a",
		"chunk-2d208dfa"
	],
	"./emptyState/batchfile-transfers.svg": [
		"fd62",
		"chunk-2d237cf0"
	],
	"./emptyState/beneficiaries.svg": [
		"d8b2",
		"chunk-2d21f45a"
	],
	"./emptyState/camara-no-access.svg": [
		"464e",
		"chunk-2d0c15a9"
	],
	"./emptyState/cards-flex.svg": [
		"4a22",
		"chunk-2d0cb6a3"
	],
	"./emptyState/cards-generic.svg": [
		"a876",
		"chunk-2d20920c"
	],
	"./emptyState/cards-kamba.svg": [
		"198b",
		"chunk-2d0ac448"
	],
	"./emptyState/cards-multicaixa.svg": [
		"7118",
		"chunk-2d0d5f77"
	],
	"./emptyState/cards-withdraw.svg": [
		"ce79",
		"chunk-2d2223ba"
	],
	"./emptyState/companyPayments-tpa-requests.svg": [
		"7472",
		"chunk-2d0d6b6e"
	],
	"./emptyState/consult-mode.svg": [
		"abfe",
		"chunk-2d213596"
	],
	"./emptyState/converter.svg": [
		"e476",
		"chunk-2d225484"
	],
	"./emptyState/favorites-folder.svg": [
		"ba92",
		"chunk-2d21a08e"
	],
	"./emptyState/filters.svg": [
		"72f5",
		"chunk-2d0d69a0"
	],
	"./emptyState/history-naHora.svg": [
		"5ded",
		"chunk-2d0d3ca4"
	],
	"./emptyState/location.svg": [
		"0509",
		"chunk-2d0a3fc4"
	],
	"./emptyState/no-favorites-cards.svg": [
		"3eee",
		"chunk-2d0c57a8"
	],
	"./emptyState/no-movements.svg": [
		"2c7d"
	],
	"./emptyState/operators-light.svg": [
		"4a4d",
		"chunk-2d0cb713"
	],
	"./emptyState/operators.svg": [
		"55fa",
		"chunk-2d0c8c51"
	],
	"./emptyState/patrimony.svg": [
		"51ae",
		"chunk-2d0c7cb6"
	],
	"./emptyState/payments.svg": [
		"df44",
		"chunk-2d229b78"
	],
	"./emptyState/savings.svg": [
		"a9b8",
		"chunk-2d209b04"
	],
	"./emptyState/search.svg": [
		"42bc",
		"chunk-2d0c0c35"
	],
	"./emptyState/search2.svg": [
		"fbd2",
		"chunk-2d237b00"
	],
	"./emptyState/statement.svg": [
		"2a78",
		"chunk-2d0bce86"
	],
	"./emptyState/transfers-international.svg": [
		"5a92",
		"chunk-2d0d2bdb"
	],
	"./emptyState/transfers-periodic.svg": [
		"4a8d",
		"chunk-2d0cb78f"
	],
	"./join-bai-direct.svg": [
		"8dfe",
		"chunk-2d0e99e1"
	],
	"./open-bank-account.svg": [
		"3dea",
		"chunk-2d0c53e3"
	],
	"./operationFeedback/error-color-reversed.svg": [
		"4e0a",
		"chunk-2d0cc598"
	],
	"./operationFeedback/error.svg": [
		"7b45",
		"chunk-2d0e17c2"
	],
	"./operationFeedback/pending-color-reversed.svg": [
		"3699",
		"chunk-2d0ba1b9"
	],
	"./operationFeedback/pending.svg": [
		"68a2",
		"chunk-2d0d0b29"
	],
	"./operationFeedback/success-color-reversed.svg": [
		"22d2",
		"chunk-2d0b2384"
	],
	"./operationFeedback/success.svg": [
		"5e2f",
		"chunk-2d0d3a3a"
	],
	"./operators.svg": [
		"1f83"
	],
	"./payments-bai-paga.svg": [
		"bb84",
		"chunk-2d21a432"
	],
	"./payments-charge-ekwanza.svg": [
		"9e0c",
		"chunk-2d0f0b75"
	],
	"./payments-education-books.svg": [
		"e686",
		"chunk-2d225c25"
	],
	"./payments-education.svg": [
		"74fd",
		"chunk-2d0d7151"
	],
	"./payments-habitation.svg": [
		"6c89",
		"chunk-2d0da7a4"
	],
	"./payments-public-services.svg": [
		"542b",
		"chunk-2d0c8245"
	],
	"./payments-reference.svg": [
		"223f",
		"chunk-2d0b1dc9"
	],
	"./payments-services.svg": [
		"3510",
		"chunk-2d0b9cf7"
	],
	"./payments-state.svg": [
		"d248",
		"chunk-2d21d848"
	],
	"./payments-turism.svg": [
		"bcbb",
		"chunk-2d21ad37"
	],
	"./payments-tv-net-telecom.svg": [
		"f7a4",
		"chunk-2d22d93a"
	],
	"./secure-association.svg": [
		"f561",
		"chunk-2d22cc80"
	],
	"./tpa.svg": [
		"632a"
	],
	"./transfers-instant.svg": [
		"f163",
		"chunk-2d22bd7e"
	],
	"./transfers-international.svg": [
		"9b2c",
		"chunk-2d0f0070"
	],
	"./transfers-kwik-manageAccounts.svg": [
		"b0ce",
		"chunk-2d20ede6"
	],
	"./transfers-kwik.svg": [
		"676c",
		"chunk-2d0d0264"
	],
	"./transfers_nacional.svg": [
		"9d79",
		"chunk-2d0f0863"
	],
	"./wallet-charge.svg": [
		"158e",
		"chunk-2d0ab547"
	],
	"./wallet-regist.svg": [
		"b228",
		"chunk-2d20ef4c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "890f";
module.exports = webpackAsyncContext;